import React, { useEffect, useState } from "react";
import { StyledLoading } from "./styles";
import ReactLoading from "react-loading";
import { useLayout } from "../../../contexts/LayoutContent";

export default function LoadingComponent() {
	const [dots, setDots] = useState("...");
	const { darkMode } = useLayout();

	useEffect(() => {
		setTimeout(() => {
			if (dots === "...") setDots(".");
			if (dots === "..") setDots("...");
			if (dots === ".") setDots("..");
		}, 300);
	}, [dots]);

	return (
		<StyledLoading>
			<ReactLoading type="spinningBubbles" color="var(--blue50)" />
			<p className="loading">Carregando{dots}</p>
		</StyledLoading>
	);
}
